module.exports = __webpack_public_path__ + "static/media/sign-up-bg.08814143.png";